import { render, staticRenderFns } from "./MealsFilterList.vue?vue&type=template&id=adb961a0&scoped=true&"
import script from "./MealsFilterList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MealsFilterList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MealsFilterList.vue?vue&type=style&index=0&id=adb961a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb961a0",
  null
  
)

export default component.exports